class ObjectUtilClass {

    /**
     * @deprecated Use e5.object.merge() instead.
     */
    public extend<Value extends Object = any>(target: Partial<Value>, ...sources: Value[]): Value {
        return this.merge(target, ...sources);
    }

    public mergeShallow<Value extends Object = any>(target: Partial<Value>, ...sources: Value[]): Value;
    public mergeShallow<Value extends Object = any>(...sources: Value[]): Value {
        const target: Partial<Value> = {};
        for (let i = 0; i < sources.length; i++) {
            if (!sources[i]) {
                continue;
            }

            for (let key in sources[i]) {

                if (sources[i][key] === undefined) {
                    continue;
                }

                if (sources[i].hasOwnProperty(key)) {
                    target[key] = sources[i][key];
                }
            }
        }
        return target as Value;
    }

    /**
     * Subsequent sources overwrite property assignments of previous sources.
     */
    public merge<Value extends Object = any>(target: Partial<Value>, ...sources: Value[]): Value;
    public merge<Value extends Object = any>(...sources: Value[]): Value {
        const target: Partial<Value> = {};
        for (let i = 0; i < sources.length; i++) {
            if (!sources[i]) {
                continue;
            }

            for (let key in sources[i]) {
                if (sources[i][key] === undefined) {
                }
                else if (sources[i][key] === target[key]) {
                }
                else if (
                    this.isLiteral(sources[i][key])
                    && this.isLiteral(target[key])) {
                    target[key] = this.merge(target[key], sources[i][key]);
                }
                // else if (
                //     this.isLiteral(sources[i][key])) {
                //     target[key] = this.merge(sources[i][key]);
                // }
                else {
                    target[key] = sources[i][key];
                }
            }
        }
        return target as Value;
    }

    /**
     * For more complex cloning use lodash merge.
     */
    public clone<Value extends Object = any>(object: Value): Value {
        if (!object) {
            return null;
        }
        const target: Partial<Value> = {};
        for (let key in object) {

            const value = object[key];

            if (value === undefined) {
            }
            else if (this.isLiteral(value)) {
                target[key] = this.clone(value);
            }
            else if (Array.isArray(value)) {
                const ary = value.slice();
                for (let i = 0; i < ary.length; ++i) {
                    if (this.isLiteral(ary[i])) {
                        ary[i] = this.clone(ary[i]);
                    }
                }
                target[key] = ary as any;
            }
            else {
                target[key] = value;
            }
        }
        return target as Value;
    }

    public isLiteral(o: any): boolean {
        if (!o) {
            return false;
        }

        if (typeof o !== "object") {
            return false;
        }

        return Object.getPrototypeOf(o) === Object.prototype;

        // if (typeof o === 'object' && o.__proto__ === Object.prototype)
        //     return true;

        //@source https://stackoverflow.com/questions/4320767/check-that-value-is-object-literal
        // if( Object.prototype.toString.call( o ) === '[object Object]' ) {
        //     return true;
        // }

        // return false;
    }
}

export const object = new ObjectUtilClass();

/**
 * @deprecated Use e5.object instead.
 */
export const ObjectUtil = object;